module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "txs-ctr"
  }, [_vm._v("Originally launched on Facebook, Rupert Fawcett’s brilliantly observed, touchingly truthful "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Off The Leash")]), _vm._v(" cartoons have developed a huge daily following around the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ctr"
  }, [_vm._v("This book brings together the very best of those cartoons, featuring the secret thoughts and conversations of dogs of every size, shape, and breed. It is a celebration of our favorite belly-scratching, tail-chasing, bed-stealing canine friends—for dog lovers everywhere.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad29ae92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fmtext.vue
// module id = 69
// module chunks = 0